"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceStatusType = void 0;
var ServiceStatusType;
(function (ServiceStatusType) {
    ServiceStatusType["ERROR"] = "ERROR";
    ServiceStatusType["INITIAL"] = "INITIAL";
    ServiceStatusType["LOADING"] = "LOADING";
    ServiceStatusType["SUCCESS"] = "SUCCESS";
})(ServiceStatusType || (exports.ServiceStatusType = ServiceStatusType = {}));
//# sourceMappingURL=status.types.js.map